export class Unidad {
    idUnidad: number = -1;
    idPadre: number = -1;
    nombreDes: string = "";
    simbolo: string = "";
}